export default "__VITE_ASSET__CDudi0yi__"